import React, {useEffect, useState} from "react";
import "./AboutPage.sass";
import logo from "../../../../images/release/logo-slim.png"
import {TabsPanel} from "../../../../_components/TabsPanel";
import SimpleGrid from "../../../../_containers/grid/SimpleGrid";
import ImageItemGrid from "../../../../_components/common/grid/ImageItemGrid";
import {
    fifth,
    fifths,
    first,
    firsts,
    fourth,
    fourths,
    second,
    seconds,
    sixth,
    sixths,
    third,
    thirds
} from "./AboutHelper";
import ImageViewer from "../../../../_components/ImageViewer";
import Window from "../../../../_containers/window/Window";
import ButtonComponent from "../../../../_components/common/buttons/ButtonComponent";
import {useNavigate} from "react-router";
import {ABOUT, COURSES} from "../../../../common/links";
import {ADDRESS} from "../../../../_api/client";

export default function AboutPage() {
    const main = `${ADDRESS}/images/about/about-main.png`

    const [photos, setPhotos] = useState()
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'КьюАй - О нас';
    }, [])

    const style = {fontSize: '0.7em'}

    return (
        <Window>
            <div className="about-header">
                <div className="about-logo">
                    <img src={logo} alt="QI Center"/>
                </div>
                <div className="about-tab-panel">
                    <TabsPanel/>
                </div>
            </div>
            <div className="about-footer">
                <div>
                    «КьюАй» – это целый мир, полный открытий и счастливых моментов. Мы больше, чем педагоги. Мы помогаем
                    детям обрести уверенность в жизни. Это возможно? Да, потому что мы создали среду, которая побуждает
                    детей учиться и развиваться. Мир ребенка будет расширяться с каждым его приходом к нам в центр.
                </div>
                <div className="about-additional">
                    <img src={main} alt="О нас"/>
                </div>
                <div>
                    Наши программы основаны на лучших мировых достижениях в области педагогики и собственном богатом
                    опыте. В нашей команде работают только профессиональные педагоги, которые находят подход к любому
                    ребенку. При этом мы постоянно развиваемся, поддерживая и укрепляя прочные и долгие отношения с
                    нашими маленькими друзьями и их родителями. Ученики центра не раз становились призерами
                    международных олимпиад и конкурсов.
                </div>
                <div>
                    Наша цель – раскрыть уникальный внутренний потенциал каждого ребенка. Дети обладают индивидуальными
                    способностями, особым типом мышления, внимания и памяти.
                    Определить эти особенности и раскрыть потенциал – значит дать большую дорогу в жизни каждого
                    ребенка.
                </div>
                <div className="about-additional">
                    <iframe style={{width: '60vw', height: '33vw'}} src="https://www.youtube.com/embed/m8hiMmSUbuY"
                            title="Жлобин ИНФО" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen></iframe>
                </div>
                <div>
                    Приходите к нам в гости!<br/>
                    Мы уверены, что вам захочется вернуться сюда снова!<br/>
                    Мы рады работать для вас!<br/>
                </div>
            </div>
            <div className="about-photos">
                <SimpleGrid>
                    <ImageItemGrid link={ABOUT}
                                   onClick={() => setPhotos(firsts)}
                                   image={first}
                                   title="Летний отдых в Болгарии"
                                   style={style}/>
                    <ImageItemGrid link={ABOUT}
                                   onClick={() => setPhotos(seconds)}
                                   image={second}
                                   title="Экскурсия в деревню к Хаски"
                                   style={style}/>
                    <ImageItemGrid link={ABOUT}
                                   onClick={() => setPhotos(thirds)}
                                   image={third}
                                   title="Летний лагерь"
                                   style={style}/>
                    <ImageItemGrid link={ABOUT}
                                   onClick={() => setPhotos(fourths)}
                                   image={fourth}
                                   title="Подготовка к школе"
                                   style={style}/>
                    <ImageItemGrid link={ABOUT}
                                   onClick={() => setPhotos(fifths)}
                                   image={fifth}
                                   title="Кубок Беларуси"
                                   style={style}/>
                    <ImageItemGrid link={ABOUT}
                                   onClick={() => setPhotos(sixths)}
                                   image={sixth}
                                   title="Экскурсия в Дукорский маёнтак"
                                   style={style}/>
                </SimpleGrid>
            </div>
            <div className="about-bottom">
                <ButtonComponent onClick={() => navigate(COURSES)}>Выбрать курс и записаться</ButtonComponent>
            </div>
            {photos && <ImageViewer photos={photos}
                                    onClose={() => setPhotos(undefined)}
                                    title="Открытый урок 2020"/>}
        </Window>
    )
}